import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { AcquirersOperatorsTable } from "./AcquirersOperatorsTable";

export const AcquirersOperatorsTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <AcquirersOperatorsTable key={field.name} readOnly={readOnly} />
        </Form.Item>
    );
};
